export default __webpack_public_path__ + "static/media/image_10.d2fbe5d7.jpg";